import { mustWatch } from '@/mocks/movies';

export default function MustWatchTimeline() {
  return (
    <section id="must" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="max-w-2xl">
            <span className="text-xs md:text-sm font-medium text-primary-600 tracking-widest">MUST WATCH</span>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              按年代挑片：必看电影的三个阶段
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              与其纠结片荒，不如按年代补片。下面按十年为一段，整理了各时期最具代表性的必看作品，适合系统性地看一遍。
            </p>
          </div>

          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
            {mustWatch.map((group, idx) => (
              <article
                key={group.id}
                className="relative rounded-lg border border-background-200/80 bg-background-100 p-5 md:p-6"
              >
                <div className="flex items-center gap-3">
                  <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading font-bold">
                    0{idx + 1}
                  </span>
                  <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-950">{group.decade}</h3>
                </div>

                <p className="mt-3 text-xs md:text-sm text-foreground-600 leading-relaxed">{group.note}</p>

                <ul className="mt-4 flex flex-col gap-2">
                  {group.films.map((film) => (
                    <li key={film} className="flex items-start gap-2 text-sm text-foreground-800">
                      <i
                        className="ri-film-fill text-primary-500 text-sm mt-0.5 shrink-0"
                        aria-hidden="true"
                      ></i>
                      <span>{film}</span>
                    </li>
                  ))}
                </ul>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}